import React, { useCallback, useEffect, useState } from "react";
import { Card, CardContent, Typography, Box, Divider } from "@mui/material";
import {
  useWasteManagement,
  WasteManagementContext,
  WasteManagementType,
} from "../../../ContextAPI/WasteManagementContext";
import dayjs from "dayjs";
import { FetchDLCCardReport } from "../../../ApiServices/ApiRequests";
import { useTranslation } from "react-i18next";
import { BinOverviewReportCard } from "../../../Models/Models";
import { useMasterData } from "../../../ContextAPI/MasterContext";
import Loading from "../../../Controller/LoadingController/Loading";

const DLCMonitoringCard: React.FC = () => {
  const { masterState } = useMasterData();
  const { wasteManagementState, dispatchWasteManagement } =
    useWasteManagement();
  const { t } = useTranslation();
  const [loading, setloading] = useState<boolean>(false);

  const handleBulkUpdate = useCallback(
    (value: Partial<WasteManagementType>) => {
      dispatchWasteManagement({ type: "BULK_UPDATE", value });
    },
    [dispatchWasteManagement]
  );

  const fetchData = async (
    siteCode: string,
    fromDate: string,
    groupId: string
  ): Promise<void> => {
    try {
      setloading(true);
      const data: BinOverviewReportCard = await FetchDLCCardReport(
        siteCode,
        fromDate,
        groupId
      );
      // Check if data.content has entries, and if so, process the report data
      const reportData =
        data && data
          ? {
              totalDLCMoniterValue: data.totalValue,
              totalDLCValueChanges: data.totalValueChanges,
              totalDLCValueColor: data.totalValueColor,
              averageFillDLClabel: data.avgValue,
              avgDLCValueChanges: data.avgValueChanges,
              avgDLCValueColor: data?.avgValueColor,

              // Ensure siteData is an empty array if report is undefined
            }
          : {
              totalDLCMoniterValue: 0,
              totalDLCValueColor: "",
              averageFillDLClabel: 0,
              avgDLCValueChanges: "",
              avgDLCValueColor: "",
              totalDLCValueChanges: "",
              // Set siteData as an empty array if content is empty
            };

      // Dispatch the data with handleBulkUpdate
      handleBulkUpdate(reportData);
    } catch (error) {
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    const formattedDate: string = masterState.reportSelectedDate
      ? masterState.reportSelectedDate.format("YYYY-MM-DD")
      : "";

    if (masterState.selectedSiteCode.length > 0) {
      fetchData(
        masterState.selectedSiteCode,
        formattedDate,
        masterState.selectedGroupCode
      );
    }
  }, [
    masterState.selectedSiteCode,
    masterState.selectedGroupCode,
    masterState.reportSelectedDate,
  ]);

  return (
    <>
      {loading ? (
        <Loading loading={loading} type={`dots`} backDrop={false} />
      ) : (
        <Box display="flex" gap={2} bgcolor={"#f9f9f9"} p={1} mt={2}>
          <Card
            sx={{
              display: "flex",
              borderLeft: "4px solid #8850ef",
              minWidth: 250,
              ml: 3,
              maxHeight: 130,
            }}
          >
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                {t("global.TotalDicMonitired")}
              </Typography>
              <Typography variant="h5">
                {t("global.Value")}:{" "}
                {wasteManagementState.totalDLCMoniterValue ?? 0}
              </Typography>
              <Typography color={wasteManagementState.totalDLCValueColor}>
                {wasteManagementState.totalDLCValueChanges ?? 0}
              </Typography>
            </CardContent>
          </Card>

          <Card
            sx={{
              display: "flex",
              borderLeft: "4px solid #8850ef",
              minWidth: 250,
              maxHeight: 130,
            }}
          >
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                {t("global.AverageFillLevel")}
              </Typography>
              <Typography variant="h5">
                {wasteManagementState.averageFillBinlabel
                  ? `${wasteManagementState.averageFillDLClabel}%`
                  : 0}
              </Typography>
              <Typography color={wasteManagementState.avgDLCValueColor}>
                {wasteManagementState.avgDLCValueChanges ?? 0}
              </Typography>
            </CardContent>
          </Card>
        </Box>
      )}
    </>
  );
};

export default DLCMonitoringCard;
